import React, {Component} from 'react';
import PrintsItem from '../components/prints-item';
import {DisplayedStatusByPrinterStatusType, PrinterStatusTypes} from "../containers/current_status_section";
import '../css/printers-card.css';
import HorizontalRuleWithContent from './horizontal-rule-with-content';
import LoadingAnimation from '../components/loading-animation';
import MaterialUsageChart from '../components/material-usage-chart';
import {addCommas} from '../modules/helpers';

class PrintersCard extends Component {
    render() {
        const {printerState, printerId, materialUsage, userId} = this.props;
        const {status, timeElapsed, timeLeft, jobData} = printerState;
        const isStatusHidden = status === PrinterStatusTypes.END
            || status === PrinterStatusTypes.CANCEL
            || status === PrinterStatusTypes.ONLINE;
        const isMaterialUsageHidden = Object.keys(materialUsage).length === 0; // empty object
        const previewFileName = `${printerId}@${userId}@${jobData.jobId}.png`;

        return <div className='printers-card-container'>
            <div className='printer-info-section'>
                <div className='printer-icon-container'><img src='/images/sprintray-printericon.svg'/></div>
                <div className='printer-name-serial-container'>
                    <strong className='large-font'>{jobData.printerName}</strong>
                    <p className='serial-font'>{this.props.printerId}</p>
                </div>
            </div>
            <HorizontalRuleWithContent content={'Active Job'} hidden={isStatusHidden}/>
            <div className='current-status-container'>
                <PrintsItem
                    displayedStatus={DisplayedStatusByPrinterStatusType[status]}
                    status={status}
                    timeElapsed={timeElapsed}
                    timeLeft={timeLeft}
                    {...jobData}
                    printerName={null}
                    isStatusItem
                    expanded={/*status !== 'offline'*/ false}
                    hidden={isStatusHidden}
                    previewFileName={previewFileName}
                />
            </div>
            <HorizontalRuleWithContent content={'Lifetime Material Usage'} hidden={isMaterialUsageHidden}/>
            {this.props.materialUsage ?
                <MaterialUsageChart materialUsageByResinName={this.props.materialUsage}
                                    loading={this.props.materialUsage.loading}/>
                : <LoadingAnimation/>}
            <HorizontalRuleWithContent/>
            <StatisticsOfPrinter
                totalNumberOfPrints={this.props.printsNumber}
                totalUsageOfResin={this.calculateTotalResinUsageOfThisPrinter()}
            />
        </div>
    }

    calculateTotalResinUsageOfThisPrinter() {
        const {materialUsage} = this.props;
        let totalResinUsage = 0;
        for (let resinName in materialUsage) {
            totalResinUsage += materialUsage[resinName];
        }
        return totalResinUsage;
    }
}

export class StatisticsOfPrinter extends Component {
    render() {
        const { printsLabel, usageLabel } = this.props;

        return <div className='number-statistics-container'>
            <div className='number-statistics-inner-container'>
                <div className='statistics-number'>{addCommas(this.props.totalNumberOfPrints)}</div>
                <div className='statistics-description'>{ printsLabel ? printsLabel : "Total Jobs Completed" }</div>
            </div>
            <div className='number-statistics-inner-container'>
                <div className='statistics-number'>{addCommas(this.props.totalUsageOfResin)} mL</div>
                <div className='statistics-description'>{ usageLabel ? usageLabel : "Total Material Used" }</div>
            </div>
        </div>
    }
}

export default PrintersCard;


// WEBPACK FOOTER //
// ./src/components/printers-card.js